/**
 * Purchase Order Detail container
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Actions from './actions';
import {
  loadingSelector,
  errorSelector,
  deliveriesSelector,
  deliverablePurchaseOrdersSelector,
  availabilitiesSelector,
  locationsSelector,
  countSelector,
} from './selectors';
import { currentUserSelector } from '../App/selectors';

import AdminActions from '../Admin/actions';
import VendorDeliveries from '../../Components/Deliveries/VendorDeliveries';
import { vendorSelector } from '../VendorApplication/selectors';

/**
 * Properties to be provided to the Purchase Order Detail component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  currentUser: currentUserSelector(state),
  count: countSelector(state),
  deliveries: deliveriesSelector(state),
  deliverablePurchaseOrders: deliverablePurchaseOrdersSelector(state),
  availabilities: availabilitiesSelector(state),
  locations: locationsSelector(state),
  vendor: vendorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch purchase order detail actions
 */
const mapDispatchToProps = (dispatch) => ({
  createDelivery: (userId, delivery, purchaseOrderNumbers) =>
    dispatch(
      Actions.createVendorDelivery(userId, delivery, purchaseOrderNumbers),
    ),
  getDelivery: (userId, deliveryId) =>
    dispatch(Actions.getVendorDelivery(userId, deliveryId)),
  getDeliveries: (userId, params) =>
    dispatch(Actions.getVendorDeliveries(userId, params)),
  getLocations: () => dispatch(Actions.getLocations()),
  getDeliverablePurchaseOrders: (id, locationId, isVendorId, params) =>
    dispatch(
      Actions.getDeliverablePurchaseOrders(id, locationId, isVendorId, params),
    ),
  updateDelivery: (userId, deliveryId, delivery, purchaseOrderNumbers) =>
    dispatch(
      Actions.updateVendorDelivery(
        userId,
        deliveryId,
        delivery,
        purchaseOrderNumbers,
      ),
    ),
  removeDelivery: (userId, deliveryId, reason) =>
    dispatch(Actions.removeVendorDelivery(userId, deliveryId, reason)),
  getAvailabilities: (options) => dispatch(Actions.getAvailabilities(options)),
  fetchVendors: (search) => dispatch(AdminActions.fetchVendors(search)),
});

/**
 * Connects login state to the Purchase Order Detail component
 *
 * @param {object} mapStateToProps data object to become props for the Purchase Order Detail component
 * @param {object} mapDispatchToProps Purchase Order Detail actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorDeliveries),
);
